import { Card, CardsWrapper, Image, OurProjectsSectionWrapper } from "./styles"
import { projectsData } from "../../util/ourProjects/ourProjects"
import { Heading } from "../../components/heading/Heading"
import { P } from "../../components/p/P"

export const OurProjectsSection = () => {

    return (
        <OurProjectsSectionWrapper>
            <p>At ND Groups , we take pride in our unwavering dedication to delivering projects that not only meet but surpass industry standards. With a focus on sustainable design, cutting-edge technology, and customer-centric solutions, we create environments that inspire and elevate the lives of our clients.</p>
            <CardsWrapper>
                {
                    projectsData.map((item, idx) => (
                            <Card key={idx}>
                                <Image src={item.img} />
                                <Heading level={3}>{item.title}</Heading>
                                <P>{item.title}</P>
                                <P style={{'color': '#3374f0'}}>{item.tag}</P>
                            </Card>
                    ))
                }
            </CardsWrapper>
        </OurProjectsSectionWrapper>
    )
}